<template>
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Αίτηση Άδειας</h4>

        <p class="card-title-desc">

        </p>

        <form @submit.prevent="submitForm">
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="validationCustom01">Από</label>
                <input
                  id="validationCustom01"
                  type="date"
                  class="form-control"
                  v-model="startDate"
                  required
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="validationCustom01">Εώς</label>
                <input
                  id="validationCustom01"
                  type="date"
                  class="form-control"
                  v-model="endDate"
                  required
                />

              </div>
            </div>
            <span v-if="isCalculatingDays">Υπολογισμός...</span>
            <span>{{holidayDaysMessage}}</span>

          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              <div class="mb-3">
                <label for="validationCustom01">Αιτία</label>
                <textarea
                  id="validationCustom01"
                  type="text"
                  class="form-control"
                  v-model="reason"
                />
              </div>
            </div>

          </div>
          <div
            class="row"
            v-if="hrmsIsActive"
          >
            <div class="col-md-12">
              <div class="mb-3">
                <label for="validationCustom01">Τύπος Άδειας</label>
                <multiselect
                  v-model="holidayTypeSelected"
                  :options="hrmsHolidayTypes"
                  track-by="leave_type"
                  label="leave_type"
                  placeholder="Επιλέξτε Τύπου"
                  selectLabel="Eπιλογή Τύπου"
                  selectedLabel="Επιλέχθηκε"
                  deselectLabel="Αποεπιλογή"
                  required
                ></multiselect>
                <p
                  v-if="showError"
                  class="text-danger mt-1"
                >
                  Παρακαλώ επιλέξτε τύπο άδειας.
                </p>
              </div>
            </div>

          </div>
          <div
            class="row"
            v-if="!hrmsIsActive"
          >
            <div class="col-md-12">
              <div class="mb-3">
                <label for="validationCustom01">Τύπος Άδειας</label>
                <multiselect
                  v-model="holidayTypeSelected"
                  :options="holidayTypeOptions"
                  track-by="title"
                  label="title"
                  placeholder="Επιλέξτε Τύπου"
                  selectLabel="Eπιλογή Τύπου"
                  selectedLabel="Επιλέχθηκε"
                  deselectLabel="Αποεπιλογή"
                  required
                ></multiselect>
                <p
                  v-if="showError"
                  class="text-danger mt-1"
                >
                  Παρακαλώ επιλέξτε τύπο άδειας.
                </p>
              </div>
            </div>

          </div>
          <button
            class="btn btn-primary"
            type="submit"
          >
            Ολοκλήρωση
          </button>
        </form>

      </div>
    </div>
  </div>

</template>


<script>
// import moment from "moment";
import session from "../../../../../api/session";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";

export default {
  props: ["hrmsIsActive", "hrmsHolidayTypes"],
  components: { Multiselect },
  data() {
    return {
      showError: false,
      startDate: null,
      endDate: null,
      reason: "",
      holidayTypeSelected: "",
      holidayTypeOptions: [],
      isCalculatingDays: false,
      holidayDaysMessage: "",
      totalHolidayDays: 0,
    };
  },
  mounted() {
    this.fetchHolidayTypes();
  },
  watch: {
    startDate: "checkAndCalculate",
    endDate: "checkAndCalculate",
  },

  methods: {
    checkAndCalculate() {
      if (this.startDate && this.endDate) {
        this.calculateTotalHolidayDays();
      } else {
        this.holidayDaysMessage = "";
      }
    },

    async getRangeDates(startDate, endDate) {
      const paramsObj = {
        start_date: startDate,
        end_date: endDate,
      };
      const params = new URLSearchParams(paramsObj);

      try {
        const resp = await session.get(
          `api/holidays-range-check/?${params.toString()}`
        );

        return resp.data.valid_days;
      } catch (e) {
        console.error("Error fetching valid days:", e);
        return 0;
      }
    },
    async calculateTotalHolidayDays() {
      this.isCalculatingDays = true;

      const validDays = await this.getRangeDates(this.startDate, this.endDate);
      this.isCalculatingDays = false;
      this.totalHolidayDays = validDays;

      this.holidayDaysMessage = `Ημέρες άδειας: ${validDays}`;
    },
    fetchHolidayTypes() {
      session
        .get("api/holidays/holiday-type-list/")
        .then((resp) => {
          this.holidayTypeOptions = resp.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    submitForm() {
      if (!this.holidayTypeSelected) {
        this.showError = true;
        return;
      } else {
        this.showError = false;
      }

      Swal.fire({
        title: "Είστε σίγουροι?",
        text: "Η αίτηση θα σταλεί!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ναι",
        cancelButtonText: "Ακυρο",
      }).then((result) => {
        if (result.value) {
          const data = {
            start_date: this.startDate,
            end_date: this.endDate,
            reason: this.reason,
            total_holiday_days: this.totalHolidayDays,
          };

          if (this.hrmsIsActive) {
            data["oracle_leave_type"] = this.holidayTypeSelected;
          } else {
            data["holiday_type"] = this.holidayTypeSelected.id;
          }
          this.$emit("requestedDone", data);

          // session
          //   .post("api/holiday-request/create/", data)
          //   .then(() => {
          //     Swal.fire("Επιτυχία!", "Η αίτηση στάλθηκε.", "success");
          //     this.$emit("requestedDone");
          //   })
          //   .catch((e) => {
          //     console.log(e);
          //     Swal.fire({
          //       title: "Ουπς! Κάτι πήγε στραβά",
          //       text: "Παρακαλώ επικοινωνήστε με τους διαχειριστές",
          //       icon: "error",
          //     });
          //   });
        }
      });
    },
  },
};
</script>